import { IconContent } from '@icons';

export const flagFilled: IconContent = {
    md: '<path d="M5 4h14l-5 4.5 5 4.5H6v7H5V4Z" />',
};
